module.exports = __webpack_public_path__ + "static/media/like.f471bb19.svg";